export default "__VITE_ASSET__ClSWDTrF__"